<template>
  <div class="job-item loop-item">
    <div class="job-image">
      <img :src="item.thumbnail" alt />
    </div>
    <div class="job-name">
      <router-link :to="{name: 'custom-order'}">{{item.name}}</router-link>
    </div>
    <div class="job-description">{{item.excerpt}}</div>
    <div class="read-more">
      <router-link :to="$i18nRoute({name: 'custom-order', params: {job: item.slug}})" class="linear-button">
        Իմանալ ավելին
        <i class="icon-right-arrow"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item']
}
</script>

<style lang="scss">
.job-item {
  .job-image {
    img {
      width: 100%;
    }
  }
  .job-name {
    margin-top: 15px;
    font-family: $font-bold;
  }
  .job-description {
    margin-top: 15px;
  }
  .read-more {
    margin-top: 30px;
    a{
      display: inline-block;
    }
  }
}
</style>
